(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('wsCardExtra', ['$document', 'AppPermissions', 'CardDisplay', 'UserRoles', 'User', 'ShareUtils', 'OrganizationSettings', 'ViewDashboardsAs', function wsCardExtra($document, AppPermissions, CardDisplay, UserRoles, User, ShareUtils, OrganizationSettings, ViewDashboardsAs) {
    return {
      templateUrl: "modules/common/directives/card-extra/card-extra.html",
      scope: {
        card: "=?",
        cardTemplate: "=?",
        extraActions: "=?",
        primaryAction: "=?"
      },
      link: function link(scope, element) {
        var session = User.get(),
          isCardAdmin = UserRoles.isOrgAdmin(session) || UserRoles.isOrgManager(session),
          isExploreAllowed = UserRoles.isExploreAllowed(session);
        scope.open = false;
        scope.viewDashboardsAs = ViewDashboardsAs;
        scope.showCardOptions = !ViewDashboardsAs.isActive;
        scope.$watch('viewDashboardsAs.isActive', function (value) {
          scope.showCardOptions = !value;
        });
        OrganizationSettings.get().then(function (orgSettings) {
          var drawer = element.find(".card-drawer");
          scope.toggleDrawer = function (event) {
            event.stopPropagation();
            scope.open = !scope.open;
            drawer.animate({
              height: "toggle"
            }, "fast", null, function () {
              if (scope.open) {
                angular.element(drawer).on("mouseleave", function (event) {
                  scope.$apply(function () {
                    if (scope.open) {
                      scope.toggleDrawer(event);
                    }
                  });
                });
              } else {
                angular.element(drawer).off("mouseleave");
              }
            });
          };
          element.on("$destroy", function () {
            angular.element($document[0].body).off();
            scope.$destroy();
          });
          var isNotShare = User.get().user !== undefined && User.get().user;
          if (isNotShare) {
            AppPermissions.getForUser({
              value: 'explorer'
            }).then(function (permissions) {
              if (scope.extraActions) {
                scope.isCardGroup = scope.card && CardDisplay._isGroupCard(scope.card);
                if (scope.cardManagementEnabled === undefined || scope.cardManagementEnabled === null) {
                  scope.cardManagementEnabled = true;
                }
                if (!CardDisplay.cardGroup || !scope.card) {
                  scope.cardManagementEnabled = false;
                } else if (!CardDisplay.cardGroup.user && !isCardAdmin) {
                  scope.cardManagementEnabled = false;
                }
                var displayAction = function displayAction(action) {
                  if (!action) {
                    return false;
                  }
                  if (orgSettings.pricingTier === "ESSENTIALS") {
                    if (scope.isCardGroup) {
                      return false;
                    } else {
                      return action.exploreCard || action.downloadData || action.advancedConfig;
                    }
                  }
                  if (scope.isCardGroup) {
                    return action.hideCard || action.unhideCard || action.renameCard || action.dashboards;
                  } else if (action.shareCard) {
                    return ShareUtils.sharingEnabled(scope.card) && OrganizationSettings.hasFeature('shareSnapshot') === true;
                  } else if (action.adoptCard) {
                    return !CardDisplay.cardGroup.user;
                  } else if (action.deleteCard) {
                    return scope.cardManagementEnabled && (scope.card || scope.card.template.explorable);
                  } else if (action.downloadData) {
                    return true;
                  } else if (action.renameCard) {
                    return false;
                  } else if (action.exploreCard || action.advancedConfig) {
                    return scope.card.template.explorable && (isExploreAllowed || permissions.length);
                  } else if (action.dashboards) {
                    return scope.cardManagementEnabled && isCardAdmin;
                  }
                  return scope.cardManagementEnabled;
                };
                scope.extraActions = _.filter(scope.extraActions, displayAction);
                scope.primaryAction = displayAction(scope.primaryAction) ? scope.primaryAction : scope.extraActions[0];

                // var half = Math.ceil(scope.extraActions.length / 2);
                // scope.actions = [scope.extraActions.slice(0, half), scope.extraActions.slice(half)];
                scope.actions = scope.extraActions;
              }
            });
          }
        });
      }
    };
  }]);
})();
